import React, { useState } from "react";
import "../App.css";

const FormulaDisplay = ({
  title = "公式与计算过程",
  children,
  defaultCollapsed = false
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  return (
    <div className="formula-display" style={{ marginTop: 24, textAlign: 'center', background: '#f9fafe', borderRadius: 12, padding: 20, boxShadow: '0 2px 8px #e5e9f2', maxWidth: 700, marginLeft: 'auto', marginRight: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
        <h4 style={{ margin: 0 }}>{title}</h4>
        <button
          onClick={() => setCollapsed(c => !c)}
          style={{ marginLeft: 16, padding: '2px 12px', borderRadius: 8, border: '1px solid #1976d2', background: '#fff', color: '#1976d2', cursor: 'pointer', fontSize: 14 }}
        >
          {collapsed ? '查看公式' : '隐藏公式'}
        </button>
      </div>
      {!collapsed && (
        <div style={{ textAlign: 'left', fontSize: 15 }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default FormulaDisplay; 